export default __webpack_public_path__ + "static/media/Maria Aparecida Sobrinho Lima.8ac6d087.png";